let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lkFiG")).then(() => parcelRequire('cgHXF'));